import type { ListBuilderList } from '../../../types';
import { createTripColumnsWithDate } from '../columns';

/**
 * Completed Routes list configuration
 * Shows completed routes
 */
export const completedTripsList: ListBuilderList = {
	id: 'completed-trips',
	name: 'Completed',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		routeStatus: {
			// Hidden for the same reason as the Open and Archived tabs: the chip
			// only repeated the tab name, and the band appearing on one tab and
			// not the others made switching tabs jump.
			hidden: true,
			defaultValue: [{ id: 'completed', label: 'Completed' }],
		},
	},
	columns: createTripColumnsWithDate(),
	defaultSortId: 'date-desc',
	sortOrder: 1,
};
